<template>
    <el-dialog v-if="videodialogVisible" top="20vh" :title="name" custom-class="v-dialog" :visible.sync="videodialogVisible"
        append-to-body>
        <swiper ref="swiper" :options="swiperOption" class="myPlayerMonitor">
            <!-- <swiper-slide v-for="(item, index) in list" :key="item.id"> -->
                <video :id="'myPlayer' + id" style="width:100%;height:auto;margin-top: 0px;" controls
                    playsInline webkit-playsinline autoplay >
                    <!-- <source :src="list"  type="rtmp/flv" /> -->
                </video>
            <!-- </swiper-slide> -->
            <!-- <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
    </el-dialog>
</template>

<script>
import PubSub from 'pubsub-js'

export default {
    name: 'JCvideo',
    data() {
        return {
            videodialogVisible: false,
            name: '查看监控',
            list: '',
            id:'0',
            swiperOption: {
                initialSlide: 0,
                speed: 1000,
                loop: false,
                observer: true,
                observeParents: true,
                // pagination: {
                //     el: '.swiper-pagination',
                // },
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // },
            }
        }
    },
    mounted() {
        PubSub.subscribe('JCvideo', (msg, data) => {
            this.videodialogVisible = data.visible
            this.list = data.list
            this.id = data.id
            // this.list = 'https://tplink.8ytech.com:10181/gethls9_9_3_0_1.m3u8?uuid=d03d106b'
            this.initVideo(this.id,this.list)
        })
    },
    methods: {
        initVideo(id,link) {
            let interval = setTimeout(() => {
                let realRef = 'myPlayer' + id;
                // new EZuikit.EZUIPlayer(realRef);
                new EZUIKit.HLS(realRef,link);
                clearTimeout(interval);
            }, 1000)
        }
    }
}
</script>

<style></style>